import React, { useState } from 'react';
import './ServiciosAdicionales.css'; // Archivo CSS separado

const ServiciosAdicionales = ({
  theme = 'light',
  servicios = [],
  loading = false,
  showForm = false,
  selectedServicio = null,
  onSelectServicio,
  onAgregarServicio,
  onCancel,
  serviciosYaAgregados = [],
}) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const getServicioSeleccionado = (servicioId) => {
    const agregados = Array.isArray(serviciosYaAgregados) ? serviciosYaAgregados : [];
    return agregados.find((s) => s.servicio_id === servicioId);
  };

  // Sistema de colores por categoría
  const serviceThemes = {
    'Aguas Domésticas': { primary: '#3b82f6', secondary: '#dbeafe', gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' },
    'Aguas Industriales': { primary: '#06b6d4', secondary: '#cffafe', gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' },
    'Excedentes Industriales': { primary: '#10b981', secondary: '#d1fae5', gradient: 'linear-gradient(135deg, #10b981 0%, #047857 100%)' },
    'Lavado de tanques': { primary: '#f59e0b', secondary: '#fef3c7', gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' },
    'Protección de Marca': { primary: '#ef4444', secondary: '#fee2e2', gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' },
    'Residuos Hospitalarios': { primary: '#8b5cf6', secondary: '#ede9fe', gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' },
    'default': { primary: '#6b7280', secondary: '#f3f4f6', gradient: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)' }
  };

  const serviceIcons = {
    'Aguas Domésticas': 'fa-house-water',
    'Aguas Industriales': 'fa-industry',
    'Excedentes Industriales': 'fa-recycle',
    'Lavado de tanques': 'fa-soap',
    'Protección de Marca': 'fa-shield-alt',
    'Residuos Hospitalarios': 'fa-hospital',
    'default': 'fa-trash-alt'
  };

  if (loading) {
    return (
      <div className="servicios-loading">
        <div className="loading-spinner"></div>
        <p>Cargando servicios...</p>
      </div>
    );
  }

  // Vista principal - Diseño visual mejorado
  if (!showForm) {
    return (
      <div className="servicios-container visible">
        <div className="servicios-header">
          <div className="header-icon">
            <i className="fas fa-recycle"></i>
          </div>
          <div className="header-text">
            <h3>Servicios Especiales</h3>
            <p>Selecciona los servicios que necesitas</p>
          </div>
        </div>

        <div className="servicios-grid">
          {servicios.map((servicio) => {
            const seleccionado = getServicioSeleccionado(servicio.id);
            const yaAgregado = !!seleccionado;
            const themeConfig = serviceThemes[servicio.nombre] || serviceThemes.default;
            const icon = serviceIcons[servicio.nombre] || serviceIcons.default;
            const isHovered = hoveredCard === servicio.id;

            return (
              <div 
                key={servicio.id}
                className={`servicio-card ${yaAgregado ? 'servicio-agregado' : ''} ${isHovered ? 'servicio-hover' : ''}`}
                onMouseEnter={() => setHoveredCard(servicio.id)}
                onMouseLeave={() => setHoveredCard(null)}
                onClick={() => !yaAgregado && onSelectServicio && onSelectServicio(servicio)}
              >
                <div className="servicio-header">
                  <div 
                    className="servicio-icon"
                    style={{ 
                      background: themeConfig.gradient,
                      boxShadow: `0 4px 15px ${themeConfig.primary}40`
                    }}
                  >
                    <i className={`fas ${icon}`}></i>
                  </div>
                  <div className="servicio-title">
                    <h4>{servicio.nombre}</h4>
                    {yaAgregado && (
                      <span className="servicio-badge">
                        <i className="fas fa-check"></i>
                        Agregado
                      </span>
                    )}
                  </div>
                </div>

                <div className="servicio-content">
                  <p className="servicio-descripcion">{servicio.descripcion}</p>
                  
                  <div className="servicio-frase">
                    <i className="fas fa-quote-left"></i>
                    {servicio.frase_sugerida}
                  </div>

                  {yaAgregado && (
                    <div className="servicio-info">
                      <div className="info-item">
                        <span className="info-label">Generación:</span>
                        <span className="info-value">{seleccionado?.rango_generacion_mensual}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Proveedor:</span>
                        <span className="info-value">{seleccionado?.proveedor_actual}</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="servicio-actions">
                  <button 
                    className={`btn-servicio ${yaAgregado ? 'btn-agregado' : 'btn-agregar'}`}
                    disabled={yaAgregado}
                    style={{
                      background: yaAgregado ? themeConfig.gradient : 'transparent',
                      borderColor: themeConfig.primary,
                      color: yaAgregado ? 'white' : themeConfig.primary
                    }}
                  >
                    <i className={`fas ${yaAgregado ? 'fa-check' : 'fa-plus'}`}></i>
                    {yaAgregado ? 'Servicio Agregado' : 'Agregar Servicio'}
                  </button>
                </div>

                {/* Elementos decorativos */}
                <div 
                  className="card-decoration"
                  style={{ background: themeConfig.gradient }}
                ></div>
                
                {isHovered && !yaAgregado && (
                  <div 
                    className="hover-effect"
                    style={{ background: themeConfig.gradient }}
                  ></div>
                )}
              </div>
            );
          })}
        </div>

        {servicios.length === 0 && (
          <div className="servicios-empty">
            <div className="empty-icon">
              <i className="fas fa-inbox"></i>
            </div>
            <h4>No hay servicios disponibles</h4>
            <p>No se encontraron servicios especiales en este momento</p>
          </div>
        )}
      </div>
    );
  }

  // Formulario visual mejorado
  return (
    <div className="servicios-form-container">
      <div className="form-header">
        <button 
          className="btn-back"
          onClick={() => onCancel && onCancel()}
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        
        <div className="form-title">
          <div 
            className="form-icon"
            style={{ 
              background: serviceThemes[selectedServicio?.nombre]?.gradient || serviceThemes.default.gradient 
            }}
          >
            <i className="fas fa-plus"></i>
          </div>
          <div>
            <h3>Agregar {selectedServicio?.nombre}</h3>
            <p>Completa la información del servicio</p>
          </div>
        </div>
      </div>

      <div className="form-content">
        <div className="form-card">
          <div className="form-section">
            <label>Descripción del Servicio</label>
            <div className="descripcion-box">
              <p>{selectedServicio?.descripcion}</p>
            </div>
          </div>

          <form onSubmit={(e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            onAgregarServicio && onAgregarServicio({
              rango_generacion_mensual: formData.get('rango_generacion_mensual'),
              proveedor_actual: formData.get('proveedor_actual'),
            });
          }}>
            <div className="form-grid">
              <div className="form-group">
                <label>Rango de Generación Mensual *</label>
                <select name="rango_generacion_mensual" required>
                  <option value="">Selecciona un rango</option>
                  <option value="0-10 KG">0 a 10 Kg</option>
                  <option value="10-100 KG">10 a 100 Kg</option>
                  <option value="101-1000 KG">101 a 1.000 Kg</option>
                  <option value=">1000 KG">&gt; 1.000 Kg</option>
                </select>
              </div>

              <div className="form-group">
                <label>Proveedor Actual *</label>
                <input 
                  type="text" 
                  name="proveedor_actual" 
                  placeholder="Nombre del proveedor actual"
                  required 
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-cancel" onClick={() => onCancel && onCancel()}>
                Cancelar
              </button>
              <button 
                type="submit" 
                className="btn-submit"
                style={{ 
                  background: serviceThemes[selectedServicio?.nombre]?.gradient || serviceThemes.default.gradient 
                }}
              >
                <i className="fas fa-plus"></i>
                Agregar Servicio
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ServiciosAdicionales;